import App from '../App';
import NotFound from '../pages/notFound';
import AboutUs from '../pages/aboutUs';
import ProductPage from '../pages/Products/products';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import Layout from './layout';
import Home from '../pages/home';
import AuthPage from '../pages/Auth/AuthPage';
import ContactForm from '../pages/contact';
import ProductDetails from '../pages/Products/productDetails';
import Wishlist from '../pages/wishlists';
import Cart from '../pages/cart';
import Category from '../pages/Category/Category';
import CategoryDetails from '../pages/Category/CategoryDetails';
import Profile from '../pages/Profile/Profile';
import Dashboard from '../pages/Dashboard/Dashboard';
const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<App />}>
            <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="about" element={<AboutUs />} />
                <Route path="products" element={<ProductPage />} />
                <Route path="product/:id" element={<ProductDetails />} />
                <Route path="contact" element={<ContactForm />} />
                <Route path="wishlist" element={<Wishlist />} />
                <Route path="cart" element={<Cart />} />
                <Route path="login" element={<AuthPage />} />
                <Route path="register" element={<AuthPage />} />
                <Route path="category" element={<Category />} />
                <Route path="categoryDetails/:id" element={<CategoryDetails />} />
                <Route path="profile" element={<Profile />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="*" element={<NotFound />} />
            </Route>
        </Route >
    )
);

export default router;
